import { FormControl, Grid, InputLabel, Stack } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React, { useContext, useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import StyledAutocomplete from "./Styles/StyledAutocomplete";
import "./Styles/listbox.css";
import { SingleSelectorGrouped } from "../Abstract/Single";
import { Team } from "../../reckon-api";
import {useReferentialContext} from "../../Context";
import TeamIcon from "../Icons/TeamIcon";

export function TeamSelect(props: { value: Team | null; updateValue: any; updateContext: boolean | undefined; label?: string }) {
    const { teamsReferential, selectedTeam, setSelectedTeam } = useReferentialContext();

    const [localTeam, setLocalTeam] = useState(props.value);

    // Sync local state when props.value changes
    useEffect(() => {
        setLocalTeam(props.value);
    }, [props.value]);

    const updateSelection = (newSelection: Team | null) => {
        if (props.updateContext) {
            setSelectedTeam(newSelection);
        } else {
            setLocalTeam(newSelection);
        }
        props.updateValue(newSelection);
    };

    return (
        <Box sx={{ minWidth: "200px", maxWidth: "300px" }}>
            <SingleSelectorGrouped
                getGroup={(option: Team) => `${option.current_league ? option.current_league : 'Other'}`}
                getOptionLabel={(option: Team) => option.name}
                getOptionShort={(option: Team) => option.name}
                options={teamsReferential}
                selected={props.updateContext ? selectedTeam : localTeam}
                updateSelection={updateSelection}
                optionDisabled={(option: any) => false}
                label={props.label ?? "Team"}
                optionDecoration={(option: { name: string; }) => <TeamIcon team_name={option.name} sx={{mr:'8px', flexShrink: 0}}/>}
                inputDecoration={(option: { name: string; }) => <TeamIcon team_name={option.name} sx={{ mr: "8px", flexShrink: 0 }} />}
            />
        </Box>
    );
}
